import apiClient from '@shared/lib/general/apiClient';
import {
  PARTNER_ORDER_CHANGE_TABLE_OPTION,
  PARTNER_ORDER_CHANGE_VALUE,
  PARTNER_ORDER_SET_ORDER,
} from '@/store/constants/mutationTypes';

const actions = {
  changePartnerOrderValue({ commit }, payload) {
    const {
      field,
      value,
    } = payload;
    commit({
      type: PARTNER_ORDER_CHANGE_VALUE,
      field,
      value,
    });
  },
  changePartnerOrderTableOption({ commit }, payload) {
    const {
      field,
      value,
    } = payload;

    commit({
      type: PARTNER_ORDER_CHANGE_TABLE_OPTION,
      field,
      value,
    });
  },
  async getOrdersForPartner({ commit, rootState }) {
    const {
      admin: {
        adminFilter: {
          corpId,
        },
      },
    } = rootState;
    try {
      const { data: orders } = await apiClient({
        method: 'GET',
        url: `/corporations/id/${corpId}/orders`,
      });
      commit({
        type: PARTNER_ORDER_SET_ORDER,
        partnerOrders: orders,
      });
    } catch (err) {
      commit('SET_SNACKBAR', {
        show: true,
        header: 'Error',
        message: err,
        status: 'error',
      });
      throw err;
    }
  },
};

export default actions;
